// DOM読み込み完了時の処理
document.addEventListener('DOMContentLoaded', function () {
  const agreeProduct = document.getElementById('product-agree');
  const buttonProduct = document.querySelector('.shopify-payment-button__button');

  // 商品ページの同意チェックボックス → 購入ボタンの状態切り替え＆カートモーダル側にも同期
  if (agreeProduct && buttonProduct) {
    agreeProduct.addEventListener('change', function () {
      if (agreeProduct.checked) {
        buttonProduct.classList.add('checkbox-checked');
      } else {
        buttonProduct.classList.remove('checkbox-checked');
      }

      // カートモーダルが表示されていれば同期
      const agreeCart = document.getElementById('cart-agree');
      const buttonCart = document.querySelector('.cart__checkout');
      if (agreeCart) {
        agreeCart.checked = agreeProduct.checked;
        if (buttonCart) {
          if (agreeCart.checked) {
            buttonCart.classList.add('checkbox-checked');
          } else {
            buttonCart.classList.remove('checkbox-checked');
          }
        }
      }
    });

    // 初期状態反映
    if (agreeProduct.checked) {
      buttonProduct.classList.add('checkbox-checked');
    } else {
      buttonProduct.classList.remove('checkbox-checked');
    }
  }

  // カートページ＆カートモーダル用チェックボックス共通処理
  const agreeCart = document.getElementById('cart-agree');
  const buttonCart = document.querySelector('.cart__checkout');

  if (agreeCart && buttonCart) {
    agreeCart.addEventListener('change', function () {
      if (agreeCart.checked) {
        buttonCart.classList.add('checkbox-checked');
      } else {
        buttonCart.classList.remove('checkbox-checked');
      }
    });

    if (agreeCart.checked) {
      buttonCart.classList.add('checkbox-checked');
    } else {
      buttonCart.classList.remove('checkbox-checked');
    }
  }
});

// カートモーダル用（モーダル表示時に呼ぶ用）
window.attachCartAgreeEvent = function () {
  const agreeCart = document.getElementById('cart-agree');
  const buttonCart = document.querySelector('.cart__checkout');
  const agreeProduct = document.getElementById('product-agree');
  const buttonProduct = document.querySelector('.shopify-payment-button__button');

  if (!agreeCart || !buttonCart) return;

  // 既存リスナー削除（多重付与防止）
  agreeCart.removeEventListener('change', handleCartAgreeChange);

  function handleCartAgreeChange() {
    if (agreeCart.checked) {
      buttonCart.classList.add('checkbox-checked');
    } else {
      buttonCart.classList.remove('checkbox-checked');
    }
    // 商品ページのチェックボックスにも同期
    if (agreeProduct) {
      agreeProduct.checked = agreeCart.checked;
      if (buttonProduct) {
        if (agreeProduct.checked) {
          buttonProduct.classList.add('checkbox-checked');
        } else {
          buttonProduct.classList.remove('checkbox-checked');
        }
      }
    }
  }
  agreeCart.addEventListener('change', handleCartAgreeChange);
  // 初期状態反映
  handleCartAgreeChange();
};

// ブラウザバック対応
window.addEventListener('pageshow', function (event) {
  if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
    const agreeProduct = document.getElementById('product-agree');
    const agreeCart = document.getElementById('cart-agree');
    const buttonProduct = document.querySelector('.shopify-payment-button__button');
    const buttonCart = document.querySelector('.cart__checkout');

    if (agreeProduct && agreeCart) {
      if (agreeProduct.checked) {
        agreeCart.checked = true;
      } else if (agreeCart.checked) {
        agreeProduct.checked = true;
      }
    }
    if (agreeProduct && buttonProduct) {
      if (agreeProduct.checked) {
        buttonProduct.classList.add('checkbox-checked');
      } else {
        buttonProduct.classList.remove('checkbox-checked');
      }
    }
    if (agreeCart && buttonCart) {
      if (agreeCart.checked) {
        buttonCart.classList.add('checkbox-checked');
      } else {
        buttonCart.classList.remove('checkbox-checked');
      }
    }
  }
});
